import { Component } from "@angular/core";
import {
  NavController,
  NavParams,
  ModalController,
  LoadingController,
  AlertController
} from "ionic-angular";
import { LoginPage } from "../login/login";
import { PerfilPage } from "../perfil/perfil";
import { AuditoriaPage } from "../auditoria/auditoria";
// import { PlebiscitoPage } from "../plebiscito/plebiscito";


import { ListaUsuariosPage } from "../lista-usuarios/lista-usuarios";
import { ListaUsuariosParceirosPage } from "../lista-usuarios-parceiros/lista-usuarios-parceiros";
import { ListagemEventoPage } from "../listagem-evento/listagem-evento";
import { ListaOperadoresPage } from "../lista-operadores/lista-operadores";
import { BancosPage } from "../bancos/bancos";

import { ListaParceirosPage } from "../lista-parceiros/lista-parceiros";
import { ListaExcluidosPage } from "../lista-excluidos/lista-excluidos";
import { CarteirinhaPage } from "../carteirinha/carteirinha";
import { AuxilioFormPage } from "../auxilio-form/auxilio-form";
import { AuxilioListPage } from "../auxilio-list/auxilio-list";



import { EventoPage } from "../evento/evento";
import { CadastroPage } from "../cadastro/cadastro";

import { Http } from "@angular/http";

import config from "../../config/config";
import { ListadeSolicitacoesPage } from "../agenda/listade-solicitacoes/listade-solicitacoes";
import { AgendamentoPage } from "../agenda/agendamento/agendamento";

@Component({
  selector: "page-home",
  templateUrl: "home.html"
})
export class HomePage {
  id:any;
  permissao = false;
  inscricao = false;
  bemvindo = {
    nome: null,
    bemVindo: null
  };
  usuario: any; 
  dados:any = {};
  dependentes = null;
  grupo: any;
  adm: boolean;
  parciais: any;
  testeInsc: boolean;
  parceiro = false;
  sesc=false;
  constructor(
    public navCtrl: NavController,
    private _http: Http,
    public loadingCtrl: LoadingController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    private alertCtrl: AlertController


  ) {}
  ngOnInit() {
    this.id = sessionStorage.getItem("id");
    this.getUsuario();
    this.testeInsc = true;
  }
  getUsuario() {
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    let env = { id: this.id };

    this._http
      .post(config.urlAPI + "usuario/unico", env, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        loading.dismiss();
        if (res.grupold == 3 || res.grupold == 2) {
          this.permissao = true;
          this.sesc = true;
        }
        if (res.grupold == 2) {
          this.adm = true;
        }if (res.grupold == 4) {
          this.parceiro = true;          
        }
        // if (res.grupold == 1) {
        // this.getVotoPlebiscito()
        // }
        this.grupo = res.grupold;
        this.usuario = res;
        this.dados = res.dados;
        this.dependentes = res.dependentes;
        if (res.grupold != 2 && this.dados.updated_at <= '2025-07-03 05:40:13' ) {
              let alert = this.alertCtrl.create({
                  title: "Atualização",
                  subTitle: "Por Favor Realize a atualização de seus dados cadastrados no sistema",
                 enableBackdropDismiss: false,
                  buttons: [
                    {
                      text: "ok",
                      handler: data => {
                        this.Perfil()
                      }
                    }
                  ]
                });
                alert.present();
        }
        // if (res.grupold == 1) {
        //   this.testeInsc = true;
        // }

        if (
          (res.dados.foto != "//public/perfildefault.jpg" &&
            res.dados.emDia == "S") ||
          this.permissao == true
        ) {
          this.inscricao = true;
        }
        if (res.dados.emDia == "S") {
          this.sesc = true
        }
        this.tratarBemvindo();
        // console.log(res);

        this.testeDeSiape(res.siape);
      })
      .catch(error => {});
  }
  goToLogout() {
    sessionStorage.clear();
    this.navCtrl.setRoot(LoginPage);
  }
  Perfil() {
    this.navCtrl.setRoot(PerfilPage, {
      usuario: this.usuario,
      dados: this.dados,
      grupo: this.grupo,
      dependentes: this.dependentes,
      bemVindo: this.bemvindo.bemVindo,
      usuarioIdAuditoria: this.usuario.id
    });
  }
  tratarBemvindo() {
    this.bemvindo.bemVindo = this.usuario.nome.split(" ")[0];
    if (this.usuario.grupold === 2) {
      this.bemvindo.bemVindo += " - Administrador";
    } else if (this.usuario.grupold === 1) {
      this.bemvindo.bemVindo += " - Sindicalizado";
    } else {
      this.bemvindo.bemVindo += " - Funcionário";
    }
  }
  // pegarParciais() {
  //   this._http
  //     .get(config.urlAPI + "usuario/parciais", {})
  //     .map(res => res.json())
  //     .toPromise()
  //     .then(res => {
  //       this.parciais = res;
  //     })
  //     .catch(error => {});
  // }
  // getVotoPlebiscito(){
  //   let loading = this.loadingCtrl.create({
  //     content: "Aguarde"
  //   });
  //   loading.present();
  //   let env = { id: this.id };

  //   this._http
  //     .get(config.urlAPI + "listar/plebiscito/"+this.id,  {})
  //     .map(res => res.json())
  //     .toPromise()
  //     .then(res => {
  //       loading.dismiss();
  //       if (Object.keys(res).length == 0) {
  //         this.navCtrl.setRoot(PlebiscitoPage, {
  //           usuario: this.usuario,
  //           grupo: this.grupo
  //         });
  //       }
  //     })
  //     .catch(error => {});
  // }

  ListaUsuario() {
    this.navCtrl.setRoot(ListaUsuariosPage, {
      usuario: this.usuario,
      grupo: this.grupo,
      bemVindo: this.usuario.bemVindo
    });
  }
  ListaUsuarioParceiros() {
    this.navCtrl.setRoot(ListaUsuariosParceirosPage, {
      usuario: this.usuario,
      grupo: this.grupo,
      bemVindo: this.usuario.bemVindo
    });
  }
  ListaOperadores() {
    this.navCtrl.setRoot(ListaOperadoresPage, {
      usuario: this.usuario,
      bemVindo: this.usuario.bemVindo,
      grupo: this.grupo
    });
  }
  ListaParceiros() {
    this.navCtrl.setRoot(ListaParceirosPage, {
      usuario: this.usuario,
      bemVindo: this.usuario.bemVindo,
      grupo: this.grupo
    });
  }
  gerenciarBancos(){
        this.navCtrl.setRoot(BancosPage, {
      usuario: this.usuario,
      dados: this.dados,
      bemVindo: this.usuario.bemVindo
    });
  }
  ListaInscritos() {
    this.navCtrl.setRoot(ListagemEventoPage, {
      usuario: this.usuario,
      dados: this.dados,
      bemVindo: this.usuario.bemVindo
    });
  }
  evento() {
    this.navCtrl.setRoot(EventoPage, {
      usuario: this.usuario,
      dados: this.dados,
      permissao: this.grupo
    });
  }
  criarConta() {
    this.navCtrl.setRoot(CadastroPage, {
      usuario: this.usuario,
      bemVindo: this.usuario.bemVindo,
      usuarioIdAuditoria: this.usuario.id
    });
  }
  ListaExcluidos() {
    this.navCtrl.setRoot(ListaExcluidosPage, {
      usuario: this.usuario,
      bemVindo: this.usuario.bemVindo
    });
  }
  carterinha() {
    this.navCtrl.setRoot(CarteirinhaPage, {
      usuario: this.usuario,
      bemVindo: this.usuario.bemVindo
    });
  }
  auxilioForm() {
    this.navCtrl.setRoot(AuxilioFormPage, {
      usuario: this.usuario,
      bemVindo: this.usuario.bemVindo,
      usuarioIdAuditoria: this.usuario.id
    });
  }
  auxilioList() {
    this.navCtrl.setRoot(AuxilioListPage, {
      usuario: this.usuario,
      bemVindo: this.usuario.bemVindo
    });
  }
  auditoria() {
    this.navCtrl.setRoot(AuditoriaPage, {});
  }

  testeDeSiape(siape) {
    let siapeArray = [
      "0361907",
      "0360229",
      "0366182",
      "1498097",
      "0364404",
      "0362608",
      "0366545",
      "1847161",
      "0372031",
      "0360429",
      "1792188",
      "2133966"
    ];
    for (let l = 0; l < siapeArray.length; l++) {
      const element = siapeArray[l];

      if (siape == element) {
        this.testeInsc = true;
      }
    }
  }
  solicitarAtendimento(){
    this.navCtrl.setRoot(AgendamentoPage, {
      usuario: this.usuario,
      bemVindo: this.usuario.bemVindo
    });
  }
  solicitacoes(){
    this.navCtrl.setRoot(ListadeSolicitacoesPage, {
      usuario: this.usuario,
      bemVindo: this.usuario.bemVindo
    });
  }
  DownloadSesc(){
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    var iframe = document.querySelector("#iframe-sesc");
    iframe.setAttribute('src','https://backend.sistema.sintufrj.org.br/public/api/gerar/sesc/'+this.usuario.siape);
    document.getElementById("iframe-sesc").click();
    setTimeout(function(){ loading.dismiss(); }, 2000);
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts